import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Header from "../../components/ui/Header2";
import ProductImageGallery from "./components/ProductImageGallery";
import ProductInfo from "./components/ProductInfo";
import CustomerReviews from "./components/CustomerReviews";
import SimilarProducts from "./components/SimilarProducts";
import BreadcrumbNavigation from "./components/BreadcrumbNavigation";
import StickyCartButton from "./components/StickyCartButton";
import Icon from "../../components/AppIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCartService,
  addToFavoritesService,
  getMyCartService,
  getProductInfoService,
  getProductRateService,
  toggleFavService,
} from "redux/services/general_service";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Footer from "../../components/common/Footer";

const ProductDetail = () => {
  const isAuthenticated = localStorage.getItem("isAuthenticated");

  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isLoadingProductInfo, productInfo, productRate, metaProductRate } =
    useSelector((state) => state.general);
  const [product, setProduct] = useState(productInfo);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [isAddingToWishlist, setIsAddingToWishlist] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [quantity, setQuantity] = useState(1);

  const productId = searchParams.get("id") || "1";

  useEffect(() => {
    dispatch(getMyCartService())
    const loadProductData = async () => {
      await dispatch(getProductInfoService(productId));
    };

    loadProductData();
  }, [productId]);

  useEffect(() => {
    setProduct(productInfo);
  }, [productInfo, productRate]);

  const handleAddToCart = async ({ product, selectedVariant, quantity }) => {
    console.log(product?.id);
    console.log(selectedVariant?.id);
    console.log(quantity);
    console.log(product);
    setIsAddingToCart(true);

    // Create a cart item object with all relevant product attributes
    const cartItem = {
      id: product.id,
      name: product.name,
      price: product.price, // Use the original price or discounted price
      price_after_discount: product?.price_after_discount,
      quantity,
      selectedOptions, // Ensure this is included
      images: product.images,
      variant: Object.values(selectedOptions).join(", ") || "Default",
      attributes: product.attributes, // Include all attributes
      category: product.category, // Include category information
      desc: product.desc, // Include product description
      has_discount: product.has_discount, // Include discount status
      in_favorite: product.in_favorite, // Include favorite status
      is_special: product.is_special, // Include special status
      new: product.new, // Include new status
      rate: product.rate, // Include product rating
      reviews: product.reviews, // Include number of reviews
      selectedVariant: selectedVariant,
    };

    if (isAuthenticated) {
      // Make API call to add to cart
      try {
        await dispatch(
          addToCartService({
            product_id: product.id,
            quantity: quantity,
            product_variant_id: selectedVariant.id,
          })
        );
       toast(t("addedToCartSucces"));
       dispatch(getMyCartService())
      } catch (error) {
        console.error("Error adding to cart:", error);
        // Handle error feedback here
      }
    } else {
      // Store in local storage for logged-out users
      const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
      const existingItem = cartItems.find(
        (item) =>
          item.id === product.id &&
          JSON.stringify(item.selectedOptions) ===
            JSON.stringify(selectedOptions)
      );

      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        cartItems.push(cartItem);
      }

      localStorage.setItem("cartItems", JSON.stringify(cartItems));
      localStorage.setItem(
        "cartCount",
        cartItems.reduce((total, item) => total + item.quantity, 0).toString()
      );

   
      window.dispatchEvent(
        new CustomEvent("cartUpdated", {
          detail: {
            count: cartItems.reduce((total, item) => total + item.quantity, 0),
            items: cartItems,
          },
        })
      );
       toast(t("addedToCartSucces"));
    }

    setIsAddingToCart(false);
    console.log(localStorage.getItem("cartItems"));
   
  };

  const handleAddToWishlist = async (product) => {
    setIsAddingToWishlist(true);

    dispatch(toggleFavService({ product_id: product?.id })).then((response) => {
      if (response?.payload?.status == 200) {
        setTimeout(() => {
          const wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");

          if (isInWishlist) {
            const updatedWishlist = wishlist.filter(
              (item) => item.id !== product.id
            );
            localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
            setIsInWishlist(false);
          } else {
            wishlist.push({
              id: product.id,
              name: product.name,
              price: product.discountedPrice || product.originalPrice,
              image: product.images[0]?.url,
              addedDate: new Date().toISOString(),
            });
            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            setIsInWishlist(true);
          }

          setIsAddingToWishlist(false);
        }, 500);
      }
    });
  };

  if (isLoadingProductInfo) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-background">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:py-24 py-8">
            <div className="animate-pulse space-y-8">
              <div className="h-4 bg-muted rounded w-1/3"></div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="aspect-square bg-muted rounded-lg"></div>
                <div className="space-y-4">
                  <div className="h-8 bg-muted rounded w-3/4"></div>
                  <div className="h-4 bg-muted rounded w-1/2"></div>
                  <div className="h-6 bg-muted rounded w-1/4"></div>
                  <div className="space-y-2">
                    <div className="h-4 bg-muted rounded"></div>
                    <div className="h-4 bg-muted rounded w-5/6"></div>
                    <div className="h-4 bg-muted rounded w-4/6"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (!product) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-background">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
            <Icon
              name="Package"
              size={64}
              className="mx-auto mb-4 text-text-secondary opacity-50"
            />
            <h1 className="text-2xl font-bold text-text-primary mb-2">
              Product Not Found
            </h1>
            <p className="text-text-secondary mb-6">
              The product you're looking for doesn't exist or has been removed.
            </p>
            <div className="space-x-4">
              <button
                onClick={() => navigate("/product-listing")}
                className="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary/90 transition-smooth"
              >
                Browse Products
              </button>
              <button
                onClick={() => navigate("/home-page")}
                className="border border-border px-6 py-2 rounded-md hover:bg-muted transition-smooth"
              >
                Go Home
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="min-h-screen bg-background">
        {/*  <BreadcrumbNavigation breadcrumbs={breadcrumbs} />*/}

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:py-24 py-8">
          {/* Main Product Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16">
            {/* Product Images */}
            <div>
              <ProductImageGallery
                images={productInfo?.images}
                videos={productInfo?.videos}
                productName={productInfo?.name}
              />
            </div>

            {/* Product Information */}
            <div>
              <ProductInfo
                product={productInfo}
                onAddToCart={handleAddToCart}
                onAddToWishlist={handleAddToWishlist}
                isInWishlist={isInWishlist}
                isAddingToCart={isAddingToCart}
                isAddingToWishlist={isAddingToWishlist}
              />
            </div>
          </div>

          {/* Customer Reviews */}
          <div className="mb-16">
            <CustomerReviews
              productId={productId}
              reviews={reviews}
              productRating={productRate}
              totalReviews={metaProductRate?.total}
              metaProductRate={metaProductRate}
            />
          </div>

          {/* Similar Products 
          <div className="mb-16">
            <SimilarProducts
              products={similarProducts}
              currentProductId={product.id}
            />
          </div>*/}
        </div>

        {/* Sticky Cart Button for Mobile */}
        <StickyCartButton
          product={product}
          selectedOptions={selectedOptions}
          quantity={quantity}
          onAddToCart={handleAddToCart}
          isAddingToCart={isAddingToCart}
        />
      </div>
      <Footer />
    </>
  );
};

export default ProductDetail;
